import $ from 'jquery';
import RemoteTable from "../remote_table";

$(document).ready(function() {

    // for COMPANY_TYPE_CHIROPRACTOR companies
    if ($('.template-order-history-chiropractor').length === 0) {
        return;
    }

    const listURL = $('#orderListURL').val();

    function getRowPopupContent(e, cell) {
        const data = cell.getData();

        const $popup = $(`
            <div>
                <div class="float-left me-4">
                    <strong>Bill To</strong>
                    <div>${data.billto_name}</div>                
                    <div class="billto_addr1">${data.billto_address1}</div>
                    <div>${data.billto_city}, ${data.billto_state}</div>
                    <div class="mb-2">${data.billto_zipcode}</div>
                </div>
                <div class="float-left">
                    <strong>Ship To</strong>
                    <div>${data.shipto_name}</div>                
                    <div class="shipto_addr1">${data.shipto_address1}</div>
                    <div>${data.shipto_city}, ${data.shipto_state}</div>
                    <div class="mb-2">${data.shipto_zipcode}</div>
                 </div>
            </div>
        `);
        if (data.bilto_address2) {
            $popup.find('.billto_addr1').after(`<div>${data.billto_address2}</div>`);
        }
        if (data.shipto_address2) {
            $popup.find('.shipto_addr1').after(`<div>${data.shipto_address2}</div>`);
        }

        return $popup[0];
    }

    const columns = [
        {
            title: 'Created',
            field: 'shopify_created_at',
            resizable: false,
            headerSort: true,
            headerSortStartingDir: 'desc',
            responsive: 0,
            clickPopup: getRowPopupContent
        },
        {
            title: 'Site',
            field: 'site.name',
            minWidth: 150,
            resizable: false,
            headerSort: false,
            headerSortStartingDir: 'desc',
            responsive: 0,
            clickPopup: getRowPopupContent
        },
        {
            title: 'Status',
            field: 'fulfillment_status',
            minWidth: 120,
            resizable: false,
            headerSort: false,
            headerSortStartingDir: 'desc',
            responsive: 1,
            clickPopup: getRowPopupContent
        },
        {
            title: 'Name',
            field: 'billto_name',
            minWidth: 120,
            resizable: false,
            headerSort: true,
            headerSortStartingDir: 'desc',
            responsive: 0,
            clickPopup: getRowPopupContent
        },
        {
            title: 'Total',
            field: 'total_amount',
            minWidth: 100,
            resizable: false,
            headerSort: true,
            headerSortStartingDir: 'desc',
            hozAlign: 'left',
            clickPopup: getRowPopupContent,
            responsive: 0,
            formatter: 'money',
            formatterParams:{
                decimal: '.',
                thousand: ',',
                symbol: '$',
                symbolAfter: '',
                negativeSign: true,
                precision: false,
            }
        },
        {
            title: 'Email',
            field: 'email',
            resizable: false,
            headerSort: true,
            headerSortStartingDir: 'desc',
            responsive: 1,
            clickPopup: getRowPopupContent
        }
    ];

    // Setup the table
    const table = new RemoteTable('#order-table', listURL, columns);

    // Setup search
    table.bindSearchInput($('#searchFilter'));
});
